import { Component, computed, inject, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ciInterface2 } from 'src/app/util/interfaces/ci';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { FileUploadModule } from 'src/app/page_component_item/file-upload/file-upload.module';
import { MspButtonComponent } from 'src/app/page_component_item/msp-button/msp-button.component';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';
import { SquarePostLoadingEffectComponent } from 'src/app/page_component_item/square-post-loading-effect/square-post-loading-effect.component';
import { CmdbRegisterPageAttachmentService } from './data/cmdb-register-page-attachment.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { FilesService } from 'src/app/services/files/files.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'pcp-cmdb-register-page-attachment',
	standalone: true,
	imports: [FileUploadModule, MspButtonComponent, FaIconComponent, SquarePostLoadingEffectComponent],
	templateUrl: './cmdb-register-page-attachment.component.html',
	styleUrl: './cmdb-register-page-attachment.component.scss',
})
export class CmdbRegisterPageAttachmentComponent implements OnInit, OnChanges {
	private readonly labelsService = inject(LabelsService);
	private readonly cmdbRegisterPageAttachmentService = inject(CmdbRegisterPageAttachmentService);
	private readonly notificationService = inject(NotificationService);
	private readonly filesService = inject(FilesService);

	icons = {
		faTrash: faTrash,
		faDownload: faDownload,
	};
	labels: LabelsInterface;

	@Input() viewType: 'read' | 'edit';
	@Input() selectedCi: ciInterface2;

	ciFileReq: Subscription;

	ciAttachments: mspFileInterface[] = [];
	newCiAttachments: mspFileInterface[] = [];
	cleanAttachments = false;

	isLoadingFiles = false;
	isUploadingFiles = false;

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();
	}

	ngOnInit(): void {
		if (this.selectedCi && this.selectedCi.id) {
			this.getCiFiles(this.selectedCi.id);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['selectedCi'] && !changes['selectedCi'].firstChange && this.selectedCi && this.selectedCi.id) {
			this.getCiFiles(this.selectedCi.id);
		}
	}

	handleFileAttachments(e): void {
		const mspFilesParsed = JSON.parse(e);
		this.newCiAttachments = mspFilesParsed;
	}

	getCiFiles(idCi: string): void {
		if (this.ciFileReq) this.ciFileReq.unsubscribe();
		this.isLoadingFiles = true;
		this.ciFileReq = this.cmdbRegisterPageAttachmentService.getFileList(idCi).subscribe({
			next: (fileList) => {
				this.ciAttachments = fileList;
			},
		});

		this.ciFileReq.add(() => {
			this.isLoadingFiles = false;
		});
	}

	uploadFiles(): void {
		if (this.isUploadingFiles || (this.newCiAttachments && this.newCiAttachments.length === 0)) return;

		this.notificationService.setNotificationMessage(this.labels.lbl_acao_demorada);
		this.isUploadingFiles = true;
		for (const [index, attachment] of this.newCiAttachments.entries()) {
			this.cmdbRegisterPageAttachmentService.uploadFiles(this.selectedCi.id, attachment).subscribe(
				(files) => {
					this.ciAttachments.push(files);

					if (index === this.newCiAttachments.length - 1) {
						this.isUploadingFiles = false;
						this.cleanAttachments = true;
						setTimeout(() => {
							this.cleanAttachments = false;
						}, 1);
					}
				},
				(errorRes) => {
					this.isUploadingFiles = false;
					this.notificationService.setNotificationMessage(this.labels.lbl_arquivo_invalido);
				}
			);
		}
	}

	deleteFile(index: number): void {
		const attachData = { ...this.ciAttachments[index] };
		this.ciAttachments.splice(index, 1);

		this.cmdbRegisterPageAttachmentService.deleteFile(this.selectedCi.id, attachData.id).subscribe(
			(res) => {},
			(errorRes) => {
				this.notificationService.setNotificationMessage(this.labels.lbl_sem_permissao_acao);
			}
		);
	}

	confirmButton(elementReference: HTMLElement): void {
		this.notificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	downloadFile(index: number): void {
		this.cmdbRegisterPageAttachmentService.getFile(this.selectedCi.id, this.ciAttachments[index].id).subscribe((mspFile) => {
			this.filesService.downloadFile(this.filesService.fileFromBase(mspFile, 'Base64'));
		});
	}
}
